import PublicationDetail from './components';

export default PublicationDetail;
